export const EXTERNAL_LINK_SERVICES = {
  AMAZON: 'AMAZON',
  BANDCAMP: 'BANDCAMP',
  BEATPORT: 'BEATPORT',
  CD_BABY: 'CD_BABY',
  DEEZER: 'DEEZER',
  GOOGLE_PLAY: 'GOOGLE_PLAY',
  GROOVE: 'GROOVE',
  ITUNES: 'ITUNES',
  SOUNDCLOUD: 'SOUNDCLOUD',
  SPOTIFY: 'SPOTIFY',
  TIDAL: 'TIDAL',
  YOUTUBE: 'YOUTUBE',
  APPLE_MUSIC: 'APPLE_MUSIC',
};

export const EXTERNAL_LINK_ACTION_TYPES = {
  BUY: 'BUY',
  LISTEN: 'LISTEN',
  WATCH: 'WATCH',
};

export const EXTERNAL_LINK_SERVICE_ACTION_TYPES = {
  [EXTERNAL_LINK_SERVICES.AMAZON]: EXTERNAL_LINK_ACTION_TYPES.BUY,
  [EXTERNAL_LINK_SERVICES.BANDCAMP]: EXTERNAL_LINK_ACTION_TYPES.BUY,
  [EXTERNAL_LINK_SERVICES.BEATPORT]: EXTERNAL_LINK_ACTION_TYPES.BUY,
  [EXTERNAL_LINK_SERVICES.CD_BABY]: EXTERNAL_LINK_ACTION_TYPES.BUY,
  [EXTERNAL_LINK_SERVICES.DEEZER]: EXTERNAL_LINK_ACTION_TYPES.LISTEN,
  [EXTERNAL_LINK_SERVICES.GOOGLE_PLAY]: EXTERNAL_LINK_ACTION_TYPES.LISTEN,
  [EXTERNAL_LINK_SERVICES.GROOVE]: EXTERNAL_LINK_ACTION_TYPES.LISTEN,
  [EXTERNAL_LINK_SERVICES.ITUNES]: EXTERNAL_LINK_ACTION_TYPES.BUY,
  [EXTERNAL_LINK_SERVICES.SOUNDCLOUD]: EXTERNAL_LINK_ACTION_TYPES.LISTEN,
  [EXTERNAL_LINK_SERVICES.SPOTIFY]: EXTERNAL_LINK_ACTION_TYPES.LISTEN,
  [EXTERNAL_LINK_SERVICES.TIDAL]: EXTERNAL_LINK_ACTION_TYPES.LISTEN,
  [EXTERNAL_LINK_SERVICES.YOUTUBE]: EXTERNAL_LINK_ACTION_TYPES.WATCH,
  [EXTERNAL_LINK_SERVICES.APPLE_MUSIC]: EXTERNAL_LINK_ACTION_TYPES.LISTEN,
};

export const EXTERNAL_LINK_SERVICE_TRANSLATIONS = {
  [EXTERNAL_LINK_SERVICES.AMAZON]: 'mgw.externalLinks.service.amazon',
  [EXTERNAL_LINK_SERVICES.BANDCAMP]: 'mgw.externalLinks.service.bandcamp',
  [EXTERNAL_LINK_SERVICES.BEATPORT]: 'mgw.externalLinks.service.beatport',
  [EXTERNAL_LINK_SERVICES.CD_BABY]: 'mgw.externalLinks.service.cdBaby',
  [EXTERNAL_LINK_SERVICES.DEEZER]: 'mgw.externalLinks.service.deezer',
  [EXTERNAL_LINK_SERVICES.GOOGLE_PLAY]: 'mgw.externalLinks.service.googlePlay',
  [EXTERNAL_LINK_SERVICES.GROOVE]: 'mgw.externalLinks.service.groove',
  [EXTERNAL_LINK_SERVICES.ITUNES]: 'mgw.externalLinks.service.iTunes',
  [EXTERNAL_LINK_SERVICES.SOUNDCLOUD]: 'mgw.externalLinks.service.soundcloud',
  [EXTERNAL_LINK_SERVICES.SPOTIFY]: 'mgw.externalLinks.service.spotify',
  [EXTERNAL_LINK_SERVICES.TIDAL]: 'mgw.externalLinks.service.tidal',
  [EXTERNAL_LINK_SERVICES.YOUTUBE]: 'mgw.externalLinks.service.youtube',
  [EXTERNAL_LINK_SERVICES.APPLE_MUSIC]: 'mgw.externalLinks.service.appleMusic',
};

export const EXTERNAL_LINK_MUSIC_PLATFORMS = {
  [EXTERNAL_LINK_SERVICES.AMAZON]: 'Amazon',
  [EXTERNAL_LINK_SERVICES.BANDCAMP]: 'Bandcamp',
  [EXTERNAL_LINK_SERVICES.BEATPORT]: 'Beatport',
  [EXTERNAL_LINK_SERVICES.CD_BABY]: 'CD Baby',
  [EXTERNAL_LINK_SERVICES.DEEZER]: 'Deezer',
  [EXTERNAL_LINK_SERVICES.GOOGLE_PLAY]: 'Google Play',
  [EXTERNAL_LINK_SERVICES.GROOVE]: 'Groove',
  [EXTERNAL_LINK_SERVICES.ITUNES]: 'iTunes',
  [EXTERNAL_LINK_SERVICES.SOUNDCLOUD]: 'Soundcloud',
  [EXTERNAL_LINK_SERVICES.SPOTIFY]: 'Spotify',
  [EXTERNAL_LINK_SERVICES.TIDAL]: 'Tidal',
  [EXTERNAL_LINK_SERVICES.YOUTUBE]: 'YouTube',
  [EXTERNAL_LINK_SERVICES.APPLE_MUSIC]: 'Apple Music',
};
